<template>
  <div class="register-icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="approval-icon">
      <circle cx="12" cy="12" r="10" />
      <path d="M9 12l2 2 4-4" />
    </svg>


  </div>
</template>

<script>
export default {
  name: "RegisterIcon",
};
</script>

<style scoped>
.register-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
